exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".card-notice {\n  cursor: pointer;\n}\n.card-notice-link {\n  width: 100%;\n  margin-top: 20px;\n}\n.card-notice-date {\n  margin: 15px 0 0 0;\n  font-size: 15px;\n  font-weight: 300;\n  line-height: 1.5;\n  color: #777;\n  text-align: right;\n}\n", ""]);

